module.exports = __webpack_public_path__ + "static/media/2020.10.1四史集中学习交流会.12648457.jpg";